export function getErrorMessage(error: any): string {
  return error?.fail?.payload?.message || error?.payload?.message || error?.message || 'Unknown Error'
}
